import type { Substance } from './types';

/** Deduplicated list of citation strings across all of a substance's receptor bindings. */
export function citationsForSubstance(substance: Substance): string[] {
  const seen = new Set<string>();
  const citations: string[] = [];

  for (const binding of substance.bindings) {
    if (!seen.has(binding.citation)) {
      seen.add(binding.citation);
      citations.push(binding.citation);
    }
  }

  return citations;
}
